// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: stretch;
}

.user-section {
  padding: 1.5rem;
  background: linear-gradient(135deg, #f9fafb 0%, #f5f7fa 100%);
  min-height: 100vh;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section {
    padding: 0.875rem;
  }
}
@media (max-width: 768px) {
  .user-section {
    padding: 0.75rem;
  }
}
.user-section .top-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions {
    gap: 0.75rem;
    margin-bottom: 0.875rem;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }
}
.user-section .top-actions .search-box {
  position: relative;
  flex: 1 1 250px;
  max-width: 400px;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions .search-box {
    flex: 1 1 300px;
    max-width: 350px;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions .search-box {
    max-width: 100%;
    flex: 1 1 100%;
  }
}
.user-section .top-actions .search-box input {
  width: 100%;
  padding: 0.7rem 1rem 0.7rem 2.8rem;
  border-radius: 12px;
  border: 1.5px solid #e0e4e8;
  font-size: 0.95rem;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
@media (max-width: 768px) {
  .user-section .top-actions .search-box input {
    padding: 0.75rem 1rem 0.75rem 2.8rem;
    font-size: 1rem;
  }
}
.user-section .top-actions .search-box input:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);
  outline: none;
  transform: translateY(-1px);
}
.user-section .top-actions .search-box input::placeholder {
  color: #9ca3af;
}
.user-section .top-actions .search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #4b5563;
  transition: color 0.3s ease;
  z-index: 1;
  pointer-events: none;
}
.user-section .top-actions .search-box:focus-within .search-icon {
  color: #1571b9;
}
.user-section .top-actions .action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions .action-buttons {
    gap: 0.4rem;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions .action-buttons {
    width: 100%;
    justify-content: stretch;
  }
}
.user-section .top-actions .action-buttons .btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.2rem;
  border: 1.5px solid #e0e4e8;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  color: #1571b9;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions .action-buttons .btn {
    padding: 0.55rem 0.85rem;
    font-size: 0.88rem;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions .action-buttons .btn {
    flex: 1;
    justify-content: center;
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
  }
}
.user-section .top-actions .action-buttons .btn.primary:hover {
  background: #1571b9;
  color: #fff;
  border-color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);
}
.user-section .top-actions .action-buttons .btn.primary:active {
  transform: translateY(0);
}
.user-section .top-actions .action-buttons .btn.info:hover {
  background: #1571b9;
  color: #fff;
  border-color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);
}
.user-section .top-actions .action-buttons .btn.info:active {
  transform: translateY(0);
}
.user-section .top-actions .action-buttons .btn.success:hover {
  background: #1571b9;
  color: #fff;
  border-color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);
}
.user-section .top-actions .action-buttons .btn.success:active {
  transform: translateY(0);
}
.user-section .top-actions .action-buttons .btn i {
  font-size: 1rem;
  transition: transform 0.3s ease;
}
.user-section .top-actions .action-buttons .btn:hover i {
  transform: scale(1.1);
}
@media (max-width: 480px) {
  .user-section .top-actions .action-buttons .btn span {
    display: none;
  }
}
.user-section .desktop-view {
  display: block;
}
@media (max-width: 768px) {
  .user-section .desktop-view {
    display: none;
  }
}
.user-section .table-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  overflow-x: auto;
  height: 66vh;
  margin-bottom: 1rem;
  border: 1px solid #e5e7eb;
  transition: box-shadow 0.3s ease;
}
.user-section .table-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}
.user-section .table-card .user-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .table-card .user-table {
    min-width: 100%;
  }
  .user-section .table-card .user-table th,
  .user-section .table-card .user-table td {
    padding: 0.6rem 0.5rem;
    font-size: 0.85rem;
    white-space: normal;
    word-wrap: break-word;
  }
  .user-section .table-card .user-table th:nth-child(1),
  .user-section .table-card .user-table td:nth-child(1) {
    min-width: 120px;
    max-width: 150px;
  }
  .user-section .table-card .user-table th:nth-child(2),
  .user-section .table-card .user-table td:nth-child(2) {
    min-width: 180px;
    max-width: 220px;
  }
  .user-section .table-card .user-table th:nth-child(2) div,
  .user-section .table-card .user-table td:nth-child(2) div {
    line-height: 1.4;
  }
  .user-section .table-card .user-table th:nth-child(2) div:first-child,
  .user-section .table-card .user-table td:nth-child(2) div:first-child {
    margin-bottom: 0.25rem;
  }
  .user-section .table-card .user-table th:nth-child(3),
  .user-section .table-card .user-table td:nth-child(3) {
    min-width: 120px;
    max-width: 150px;
  }
  .user-section .table-card .user-table th:nth-child(4),
  .user-section .table-card .user-table td:nth-child(4) {
    min-width: 80px;
    max-width: 100px;
  }
  .user-section .table-card .user-table th:nth-child(5),
  .user-section .table-card .user-table td:nth-child(5) {
    min-width: 110px;
    max-width: 130px;
  }
  .user-section .table-card .user-table th:nth-child(6),
  .user-section .table-card .user-table td:nth-child(6) {
    min-width: 120px;
    max-width: 140px;
  }
  .user-section .table-card .user-table .actions {
    flex-wrap: wrap;
    gap: 0.3rem;
  }
  .user-section .table-card .user-table .actions .icon-btn {
    padding: 0.25rem;
    min-width: 32px;
    min-height: 32px;
  }
  .user-section .table-card .user-table .actions .icon-btn i {
    font-size: 0.9rem;
  }
}
.user-section .table-card .user-table th,
.user-section .table-card .user-table td {
  padding: 0.75rem 0.65rem;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  white-space: nowrap;
  font-size: 0.9rem;
}
.user-section .table-card .user-table thead {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: sticky;
  top: 0;
  z-index: 10;
}
.user-section .table-card .user-table thead th {
  font-weight: 600;
  font-size: 0.9rem;
  color: #1f2937;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  padding: 0.75rem 0.65rem;
}
.user-section .table-card .user-table tbody tr {
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}
.user-section .table-card .user-table tbody tr:hover {
  background: #f8fafc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.user-section .table-card .user-table tbody .no-record {
  text-align: center;
  color: #9ca3af;
  font-style: italic;
  padding: 2rem;
  font-size: 1rem;
}
.user-section .table-card .user-table .status {
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.user-section .table-card .user-table .status.active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border: 1px solid #6ee7b7;
}
.user-section .table-card .user-table .status.inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border: 1px solid #fca5a5;
}
.user-section .table-card .user-table .actions {
  display: flex;
  gap: 0.5rem;
}
.user-section .table-card .user-table .actions .icon-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}
.user-section .table-card .user-table .actions .icon-btn i {
  font-size: 1.1rem;
  transition: transform 0.3s ease;
}
.user-section .table-card .user-table .actions .icon-btn.success {
  color: #10b981;
}
.user-section .table-card .user-table .actions .icon-btn.success:hover {
  background: rgba(16, 185, 129, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.2);
}
.user-section .table-card .user-table .actions .icon-btn.success:hover i {
  transform: rotate(180deg) scale(1.1);
}
.user-section .table-card .user-table .actions .icon-btn.warning {
  color: #1571b9;
}
.user-section .table-card .user-table .actions .icon-btn.warning:hover {
  background: rgba(21, 114, 185, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(21, 114, 185, 0.2);
}
.user-section .table-card .user-table .actions .icon-btn.warning:hover i {
  transform: scale(1.15);
}
.user-section .table-card .user-table .actions .icon-btn.danger {
  color: #ef4444;
}
.user-section .table-card .user-table .actions .icon-btn.danger:hover {
  background: rgba(239, 68, 68, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.2);
}
.user-section .table-card .user-table .actions .icon-btn.danger:hover i {
  transform: scale(1.15);
}
.user-section .mobile-view {
  display: none;
}
@media (max-width: 768px) {
  .user-section .mobile-view {
    display: block;
  }
}
.user-section .mobile-view .no-record-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  color: #888;
  font-style: italic;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.user-section .mobile-view .client-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
  padding: 1rem;
  transition: all 0.3s ease;
}
.user-section .mobile-view .client-card:active {
  transform: scale(0.98);
}
.user-section .mobile-view .client-card .client-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #eaeaea;
}
.user-section .mobile-view .client-card .client-card-header .client-name {
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
  flex: 1;
}
.user-section .mobile-view .client-card .client-card-header .status {
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.user-section .mobile-view .client-card .client-card-header .status.active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border: 1px solid #6ee7b7;
}
.user-section .mobile-view .client-card .client-card-header .status.inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border: 1px solid #fca5a5;
}
.user-section .mobile-view .client-card .client-card-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row i {
  color: #1571b9;
  font-size: 1.1rem;
  margin-top: 0.2rem;
  min-width: 20px;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row .info-label {
  font-size: 0.75rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row .info-value {
  font-size: 0.95rem;
  color: #333;
  word-break: break-word;
}
.user-section .mobile-view .client-card .client-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eaeaea;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn i {
  font-size: 1.1rem;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.success {
  color: #28a745;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.success:active {
  background: rgba(40, 167, 69, 0.2);
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.warning {
  color: #1571b9;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.warning:active {
  background: rgba(21, 114, 185, 0.2);
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.danger {
  color: #dc3545;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.danger:active {
  background: rgba(220, 53, 69, 0.2);
}
.user-section .pagination-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  font-family: "Inter", sans-serif;
  transition: all 0.3s ease-in-out;
}
.user-section .pagination-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .pagination-container {
    padding: 0.65rem 1rem;
  }
}
.user-section .pagination-container .pagination-info {
  color: #374151;
  font-size: 0.95rem;
  font-weight: 500;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .pagination-container .pagination-info {
    font-size: 0.9rem;
  }
}
.user-section .pagination-container .pagination-info span {
  background: #f3f4f6;
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .pagination-container .pagination-info span {
    padding: 0.3rem 0.65rem;
  }
}
.user-section .pagination-container .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination {
  margin: 0;
  list-style: none;
  padding: 0;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li {
  align-items: center;
  vertical-align: middle;
  margin: 0 0.25rem;
  height: 30px;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li.active a {
  background: linear-gradient(90deg, #2563eb, #1d4ed8);
  color: #fff !important;
  border-color: transparent;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  font-size: 0.9rem;
  color: #374151;
  background: #f9fafb;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 500;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a:hover {
  background: #e5e7eb;
  border-color: #1571b9;
  color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li.disabled a {
  opacity: 0.5;
  cursor: not-allowed;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination .current span {
  height: 25px;
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .user-section .pagination-container {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
  }
  .user-section .pagination-container .pagination-info {
    order: 2;
  }
  .user-section .pagination-container .pagination-controls {
    order: 1;
  }
}

textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1.5px solid #e0e4e8;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  font-size: 0.95rem;
  font-family: inherit;
  resize: vertical;
}
@media (min-width: 750px) and (max-width: 1300px) {
  textarea {
    padding: 0.55rem 0.6rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  textarea {
    padding: 0.75rem;
    font-size: 1rem;
  }
}
textarea:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12);
  outline: none;
  transform: translateY(-1px);
}
textarea::placeholder {
  color: #9ca3af;
}

.custom-modal {
  position: fixed;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.custom-modal.is-active {
  display: flex;
}
.custom-modal .custom-modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}
.custom-modal .custom-modal-container {
  position: relative;
  z-index: 2;
  background: #fff;
  border-radius: 1.25rem;
  width: 90%;
  max-width: 800px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2rem;
  animation: modalSlideIn 0.3s ease-out;
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-container {
    width: 85%;
    max-width: 750px;
    padding: 1rem 1.25rem;
    max-height: 95vh;
  }
}
@media (max-width: 768px) {
  .custom-modal .custom-modal-container {
    width: 95%;
    max-height: 95vh;
    border-radius: 0.75rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-container {
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
    padding: 0.75rem;
  }
}
.custom-modal .custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  order: 0;
}
.custom-modal .custom-modal-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}
.custom-modal .custom-modal-header .close-btn {
  background: #f3f4f6;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #6b7280;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.custom-modal .custom-modal-header .close-btn:hover {
  background: #e5e7eb;
  color: #1f2937;
  transform: rotate(90deg);
}
.custom-modal .custom-modal-body {
  margin-top: 1rem;
  flex: 1;
  overflow-y: auto;
}
.custom-modal .form-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.custom-modal .form-grid .input-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .form-grid .input-row {
    gap: 0.875rem;
  }
}
@media (max-width: 768px) {
  .custom-modal .form-grid .input-row {
    flex-direction: column;
    gap: 0.75rem;
  }
}
.custom-modal .form-grid .input-row .input-group {
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .form-grid .input-row .input-group {
    min-width: 180px;
    flex: 1 1 calc(33.333% - 0.583rem);
  }
  .custom-modal .form-grid .input-row .input-group:only-child, .custom-modal .form-grid .input-row .input-group:nth-child(2):last-child {
    flex: 1 1 calc(50% - 0.4375rem);
  }
}
@media (max-width: 768px) {
  .custom-modal .form-grid .input-row .input-group {
    min-width: 100%;
    flex: 1 1 100%;
  }
}
.custom-modal .form-grid .input-row .input-group label {
  font-weight: 500;
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
}
@media (max-width: 480px) {
  .custom-modal .form-grid .input-row .input-group label {
    font-size: 0.85rem;
  }
}
.custom-modal .form-grid .input-row .input-group label span {
  color: #ff4757;
}
.custom-modal .form-grid .input-row .input-group input,
.custom-modal .form-grid .input-row .input-group select {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  transition: all 0.3s;
  font-size: 0.95rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .form-grid .input-row .input-group input,
  .custom-modal .form-grid .input-row .input-group select {
    padding: 0.55rem 0.6rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .form-grid .input-row .input-group input,
  .custom-modal .form-grid .input-row .input-group select {
    padding: 0.75rem;
    font-size: 1rem;
  }
}
.custom-modal .form-grid .input-row .input-group input:focus,
.custom-modal .form-grid .input-row .input-group select:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12);
  outline: none;
  transform: translateY(-1px);
}
.custom-modal .form-grid .input-row .input-group input::placeholder,
.custom-modal .form-grid .input-row .input-group select::placeholder {
  color: #9ca3af;
}
.custom-modal .form-grid .input-row .input-group form-validation {
  display: block;
  margin-top: 0.25rem;
  min-height: 1.2rem;
}
.custom-modal .form-grid .input-row.full-width {
  width: 100%;
}
.custom-modal .form-grid .profile-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
}
.custom-modal .form-grid .profile-section .profile-wrapper {
  position: relative;
  text-align: center;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e5e7eb;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-image:hover {
  border-color: #1571b9;
  box-shadow: 0 6px 16px rgba(21, 113, 185, 0.2);
  transform: scale(1.05);
}
@media (max-width: 480px) {
  .custom-modal .form-grid .profile-section .profile-wrapper .profile-image {
    width: 80px;
    height: 80px;
  }
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action .file-label {
  cursor: pointer;
  color: #1571b9;
  font-size: 1rem;
  padding: 0.5rem;
}
@media (max-width: 480px) {
  .custom-modal .form-grid .profile-section .profile-wrapper .profile-action .file-label {
    font-size: 0.9rem;
  }
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action .remove-btn {
  background: none;
  border: none;
  color: #ff4757;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.5rem;
}
@media (max-width: 480px) {
  .custom-modal .form-grid .profile-section .profile-wrapper .profile-action .remove-btn {
    font-size: 0.85rem;
  }
}
.custom-modal .custom-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #eee;
  padding-top: 0.8rem;
  margin-top: 1rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-footer {
    gap: 0.875rem;
    padding-top: 0.75rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-footer {
    flex-direction: column-reverse;
    gap: 0.75rem;
  }
}
.custom-modal .custom-modal-footer .primary-btn {
  background: linear-gradient(135deg, #1571b9 0%, #0d5a9a 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.75rem 1.8rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.3);
  font-size: 0.95rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-footer .primary-btn {
    padding: 0.55rem 1.2rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-footer .primary-btn {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }
}
.custom-modal .custom-modal-footer .primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.custom-modal .custom-modal-footer .primary-btn:hover:not(:disabled) {
  background-color: #1571b9;
}
.custom-modal .custom-modal-footer .primary-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.custom-modal .custom-modal-footer .cancel-btn {
  background-color: #f9fafb;
  color: #374151;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.75rem 1.8rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.95rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-footer .cancel-btn {
    padding: 0.55rem 1.2rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-footer .cancel-btn {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }
}
.custom-modal .custom-modal-footer .cancel-btn:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.custom-modal .custom-modal-footer .cancel-btn:active {
  transform: translateY(0);
}
.custom-modal .file-upload-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.custom-modal .file-upload-section input[type=file] {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  background: #fff;
  cursor: pointer;
}
.custom-modal .file-upload-section .attachment-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.custom-modal .file-upload-section .attachment-list .attachment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background: #f5f5f5;
  border-radius: 0.4rem;
  font-size: 0.9rem;
}
@media (max-width: 480px) {
  .custom-modal .file-upload-section .attachment-list .attachment-item {
    padding: 0.75rem;
    font-size: 0.85rem;
  }
}
.custom-modal .file-upload-section .attachment-list .attachment-item span {
  flex: 1;
  word-break: break-word;
  margin-right: 0.5rem;
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 0.2rem 0.5rem;
  border-radius: 0.3rem;
  transition: all 0.2s;
  flex-shrink: 0;
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment:hover {
  background: rgba(220, 53, 69, 0.1);
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment:active {
  background: rgba(220, 53, 69, 0.2);
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment i {
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/manageclient/manageclient.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,eAAA;EACA,6DAAA;EACA,iBAAA;AACF;AAEE;EANF;IAOI,iBAAA;EACF;AACF;AACE;EAVF;IAWI,gBAAA;EAEF;AACF;AAAI;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;AAEJ;AACI;EATA;IAUE,YAAA;IACA,uBAAA;EAEJ;AACF;AAAI;EAdA;IAeE,sBAAA;IACA,oBAAA;IACA,YAAA;IACA,sBAAA;EAGJ;AACF;AADI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAGN;AAAM;EANF;IAOI,eAAA;IACA,gBAAA;EAGN;AACF;AADM;EAXF;IAYI,eAAA;IACA,cAAA;EAIN;AACF;AAFM;EACE,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yCAAA;AAIR;AAFQ;EAVF;IAWI,oCAAA;IACA,eAAA;EAKR;AACF;AAHQ;EACE,qBAAA;EACA,6EAAA;EACA,aAAA;EACA,2BAAA;AAKV;AAFQ;EACE,cAAA;AAIV;AAAM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,2BAAA;EACA,UAAA;EACA,oBAAA;AAER;AACM;EACE,cAAA;AACR;AAGI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AADN;AAIM;EANF;IAOI,WAAA;EADN;AACF;AAGM;EAVF;IAWI,WAAA;IACA,wBAAA;EAAN;AACF;AAEM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iDAAA;EACA,yCAAA;AAAR;AAGQ;EAhBF;IAiBI,wBAAA;IACA,kBAAA;EAAR;AACF;AAEQ;EArBF;IAsBI,OAAA;IACA,uBAAA;IACA,qBAAA;IACA,kBAAA;EACR;AACF;AAEU;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,+CAAA;AAAZ;AAGU;EACE,wBAAA;AADZ;AAMU;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,+CAAA;AAJZ;AAOU;EACE,wBAAA;AALZ;AAUU;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,+CAAA;AARZ;AAWU;EACE,wBAAA;AATZ;AAaQ;EACE,eAAA;EACA,+BAAA;AAXV;AAcQ;EACE,qBAAA;AAZV;AAgBU;EADF;IAEI,aAAA;EAbV;AACF;AAoBE;EACE,cAAA;AAlBJ;AAoBI;EAHF;IAII,aAAA;EAjBJ;AACF;AAoBE;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AAlBJ;AAoBI;EACE,0CAAA;AAlBN;AAqBI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAnBN;AAsBM;EANF;IAOI,eAAA;EAnBN;EAqBM;;IAEE,sBAAA;IACA,kBAAA;IACA,mBAAA;IACA,qBAAA;EAnBR;EAsBM;;IAEE,gBAAA;IACA,gBAAA;EApBR;EAuBM;;IAEE,gBAAA;IACA,gBAAA;EArBR;EAuBQ;;IACE,gBAAA;EApBV;EAsBU;;IACE,sBAAA;EAnBZ;EAwBM;;IAEE,gBAAA;IACA,gBAAA;EAtBR;EAyBM;;IAEE,eAAA;IACA,gBAAA;EAvBR;EA0BM;;IAEE,gBAAA;IACA,gBAAA;EAxBR;EA2BM;;IAEE,gBAAA;IACA,gBAAA;EAzBR;EA4BM;IACE,eAAA;IACA,WAAA;EA1BR;EA4BQ;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;EA1BV;EA4BU;IACE,iBAAA;EA1BZ;AACF;AA+BM;;EAEE,wBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;AA7BR;AAgCM;EACE,6DAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AA9BR;AAgCQ;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;AA9BV;AAmCQ;EACE,4DAAA;AAjCV;AAmCU;EACE,mBAAA;EACA,yCAAA;AAjCZ;AAqCQ;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAnCV;AAuCM;EACE,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yCAAA;AArCR;AAuCQ;EACE,6DAAA;EACA,cAAA;EACA,yBAAA;AArCV;AAwCQ;EACE,6DAAA;EACA,cAAA;EACA,yBAAA;AAtCV;AA0CM;EACE,aAAA;EACA,WAAA;AAxCR;AA0CQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAxCV;AA0CU;EACE,iBAAA;EACA,+BAAA;AAxCZ;AA2CU;EACE,cAAA;AAzCZ;AA2CY;EACE,oCAAA;EACA,2BAAA;EACA,6CAAA;AAzCd;AA2Cc;EACE,oCAAA;AAzChB;AA8CU;EACE,cAAA;AA5CZ;AA8CY;EACE,oCAAA;EACA,2BAAA;EACA,6CAAA;AA5Cd;AA8Cc;EACE,sBAAA;AA5ChB;AAiDU;EACE,cAAA;AA/CZ;AAiDY;EACE,mCAAA;EACA,2BAAA;EACA,4CAAA;AA/Cd;AAiDc;EACE,sBAAA;AA/ChB;AAyDE;EACE,aAAA;AAvDJ;AAyDI;EAHF;IAII,cAAA;EAtDJ;AACF;AAwDI;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;AAtDN;AAyDI;EACE,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAvDN;AAyDM;EACE,sBAAA;AAvDR;AA0DM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAxDR;AA0DQ;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;AAxDV;AA2DQ;EACE,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yCAAA;AAzDV;AA2DU;EACE,6DAAA;EACA,cAAA;EACA,yBAAA;AAzDZ;AA4DU;EACE,6DAAA;EACA,cAAA;EACA,yBAAA;AA1DZ;AA+DM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AA7DR;AA+DQ;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AA7DV;AA+DU;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA7DZ;AAgEU;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AA9DZ;AAiEU;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;AA/DZ;AAoEM;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,6BAAA;AAlER;AAoEQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlEV;AAoEU;EACE,iBAAA;AAlEZ;AAqEU;EACE,cAAA;AAnEZ;AAqEY;EACE,kCAAA;AAnEd;AAuEU;EACE,cAAA;AArEZ;AAuEY;EACE,mCAAA;AArEd;AAyEU;EACE,cAAA;AAvEZ;AAyEY;EACE,kCAAA;AAvEd;AA+EE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gCAAA;EACA,gCAAA;AA7EJ;AA+EI;EACE,yCAAA;AA7EN;AAiFI;EAlBF;IAmBI,qBAAA;EA9EJ;AACF;AAgFI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA9EN;AAiFM;EANF;IAOI,iBAAA;EA9EN;AACF;AAgFM;EACE,mBAAA;EACA,wBAAA;EACA,kBAAA;AA9ER;AAgFQ;EALF;IAMI,uBAAA;EA7ER;AACF;AAiFI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA/EN;AAkFQ;EACE,SAAA;EAEA,gBAAA;EACA,UAAA;AAjFV;AAmFU;EAEE,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AAlFZ;AAoFY;EACE,oDAAA;EACA,sBAAA;EACA,yBAAA;AAlFd;AAqFY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iDAAA;EACA,gBAAA;AAnFd;AAqFc;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,wCAAA;AAnFhB;AAuFY;EACE,YAAA;EACA,mBAAA;AArFd;AAwFU;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAtFZ;AA6FI;EA3GF;IA4GI,sBAAA;IACA,mBAAA;IACA,YAAA;EA1FJ;EA4FI;IACE,QAAA;EA1FN;EA6FI;IACE,QAAA;EA3FN;AACF;;AAkGA;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iDAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AA/FF;AAkGE;EAZF;IAaI,uBAAA;IACA,iBAAA;EA/FF;AACF;AAiGE;EAjBF;IAkBI,gBAAA;IACA,eAAA;EA9FF;AACF;AAgGE;EACE,qBAAA;EACA,8CAAA;EACA,aAAA;EACA,2BAAA;AA9FJ;AAiGE;EACE,cAAA;AA/FJ;;AAmGA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAhGF;AAkGE;EACE,aAAA;AAhGJ;AAmGE;EACE,kBAAA;EACA,QAAA;EACA,8BAAA;AAjGJ;AAoGE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,qCAAA;AAlGJ;AAoGI;EACE;IACE,UAAA;IACA,wCAAA;EAlGN;EAoGI;IACE,UAAA;IACA,iCAAA;EAlGN;AACF;AAsGI;EA3BF;IA4BI,UAAA;IACA,gBAAA;IACA,qBAAA;IACA,gBAAA;EAnGJ;AACF;AAqGI;EAlCF;IAmCI,UAAA;IACA,gBAAA;IACA,sBAAA;EAlGJ;AACF;AAoGI;EAxCF;IAyCI,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAjGJ;AACF;AAoGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAlGJ;AAoGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAlGN;AAqGI;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAnGN;AAqGM;EACE,mBAAA;EACA,cAAA;EACA,wBAAA;AAnGR;AAwGE;EACE,gBAAA;EACA,OAAA;EACA,gBAAA;AAtGJ;AAyGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvGJ;AAyGI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AAvGN;AA0GM;EAPF;IAQI,aAAA;EAvGN;AACF;AAyGM;EAXF;IAYI,sBAAA;IACA,YAAA;EAtGN;AACF;AAwGM;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAtGR;AAyGQ;EAPF;IAQI,gBAAA;IACA,kCAAA;EAtGR;EAyGQ;IAEE,+BAAA;EAxGV;AACF;AA2GQ;EAlBF;IAmBI,eAAA;IACA,cAAA;EAxGR;AACF;AA0GQ;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AAxGV;AA0GU;EANF;IAOI,kBAAA;EAvGV;AACF;AAyGU;EACE,cAAA;AAvGZ;AA2GQ;;EAEE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAzGV;AA4GU;EAVF;;IAWI,uBAAA;IACA,iBAAA;EAxGV;AACF;AA0GU;EAfF;;IAgBI,gBAAA;IACA,eAAA;EAtGV;AACF;AAwGU;;EACE,qBAAA;EACA,8CAAA;EACA,aAAA;EACA,2BAAA;AArGZ;AAwGU;;EACE,cAAA;AArGZ;AAyGQ;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AAvGV;AA2GM;EACE,WAAA;AAzGR;AA6GI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AA3GN;AA6GM;EACE,kBAAA;EACA,kBAAA;AA3GR;AA6GQ;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yCAAA;AA3GV;AA6GU;EACE,qBAAA;EACA,8CAAA;EACA,sBAAA;AA3GZ;AA8GU;EAhBF;IAiBI,WAAA;IACA,YAAA;EA3GV;AACF;AA8GQ;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AA5GV;AA8GU;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AA5GZ;AA8GY;EANF;IAOI,iBAAA;EA3GZ;AACF;AA8GU;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA5GZ;AA8GY;EARF;IASI,kBAAA;EA3GZ;AACF;AAkHE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;AAhHJ;AAmHI;EATF;IAUI,aAAA;IACA,oBAAA;EAhHJ;AACF;AAkHI;EAdF;IAeI,8BAAA;IACA,YAAA;EA/GJ;AACF;AAiHI;EACE,6DAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;EACA,8CAAA;EACA,kBAAA;AA/GN;AAkHM;EAbF;IAcI,uBAAA;IACA,iBAAA;EA/GN;AACF;AAiHM;EAlBF;IAmBI,WAAA;IACA,qBAAA;IACA,eAAA;EA9GN;AACF;AAgHM;EACE,YAAA;EACA,mBAAA;AA9GR;AAiHM;EACE,yBAAA;AA/GR;AAkHM;EACE,sBAAA;AAhHR;AAoHI;EACE,yBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;EACA,kBAAA;AAlHN;AAqHM;EAZF;IAaI,uBAAA;IACA,iBAAA;EAlHN;AACF;AAoHM;EAjBF;IAkBI,WAAA;IACA,qBAAA;IACA,eAAA;EAjHN;AACF;AAmHM;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;EACA,wCAAA;AAjHR;AAoHM;EACE,wBAAA;AAlHR;AAuHE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AArHJ;AAuHI;EACE,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AArHN;AAwHI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAtHN;AAwHM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AAtHR;AAwHQ;EATF;IAUI,gBAAA;IACA,kBAAA;EArHR;AACF;AAuHQ;EACE,OAAA;EACA,sBAAA;EACA,oBAAA;AArHV;AAwHQ;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;AAtHV;AAwHU;EACE,kCAAA;AAtHZ;AAyHU;EACE,kCAAA;AAvHZ;AA0HU;EACE,iBAAA;AAxHZ","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: stretch;\n}\n\n.user-section {\n  padding: 1.5rem;\n  background: linear-gradient(135deg, #f9fafb 0%, #f5f7fa 100%);\n  min-height: 100vh;\n\n  // Tablet optimization (750px - 1300px)\n  @media (min-width: 750px) and (max-width: 1300px) {\n    padding: 0.875rem;\n  }\n\n  @media (max-width: 768px) {\n    padding: 0.75rem;\n  }\n\n    .top-actions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    gap: 1rem;\n\n    // Tablet optimization (750px - 1300px)\n    @media (min-width: 750px) and (max-width: 1300px) {\n      gap: 0.75rem;\n      margin-bottom: 0.875rem;\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 0.75rem;\n      margin-bottom: 0.75rem;\n    }\n\n    .search-box {\n      position: relative;\n      flex: 1 1 250px;\n      max-width: 400px;\n\n      // Tablet optimization (750px - 1300px)\n      @media (min-width: 750px) and (max-width: 1300px) {\n        flex: 1 1 300px;\n        max-width: 350px;\n      }\n\n      @media (max-width: 768px) {\n        max-width: 100%;\n        flex: 1 1 100%;\n      }\n\n      input {\n        width: 100%;\n        padding: 0.7rem 1rem 0.7rem 2.8rem;\n        border-radius: 12px;\n        border: 1.5px solid #e0e4e8;\n        font-size: 0.95rem;\n        background: #fff;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n\n        @media (max-width: 768px) {\n          padding: 0.75rem 1rem 0.75rem 2.8rem;\n          font-size: 1rem; // Prevent zoom on iOS\n        }\n\n        &:focus {\n          border-color: #1571b9;\n          box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);\n          outline: none;\n          transform: translateY(-1px);\n        }\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n      }\n\n      .search-icon {\n        position: absolute;\n        left: 12px;\n        top: 50%;\n        transform: translateY(-50%);\n        color: #4b5563;\n        transition: color 0.3s ease;\n        z-index: 1;\n        pointer-events: none;\n      }\n\n      &:focus-within .search-icon {\n        color: #1571b9;\n      }\n    }\n\n    .action-buttons {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n\n      // Tablet optimization (750px - 1300px)\n      @media (min-width: 750px) and (max-width: 1300px) {\n        gap: 0.4rem;\n      }\n\n      @media (max-width: 768px) {\n        width: 100%;\n        justify-content: stretch;\n      }\n\n      .btn {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.65rem 1.2rem;\n        border: 1.5px solid #e0e4e8;\n        border-radius: 10px;\n        font-size: 0.9rem;\n        font-weight: 500;\n        cursor: pointer;\n        color: #1571b9;\n        background: #fff;\n        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n\n        // Tablet optimization (750px - 1300px)\n        @media (min-width: 750px) and (max-width: 1300px) {\n          padding: 0.55rem 0.85rem;\n          font-size: 0.88rem;\n        }\n\n        @media (max-width: 768px) {\n          flex: 1;\n          justify-content: center;\n          padding: 0.75rem 1rem;\n          font-size: 0.95rem;\n        }\n\n        &.primary {\n          &:hover {\n            background: #1571b9;\n            color: #fff;\n            border-color: #1571b9;\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);\n          }\n\n          &:active {\n            transform: translateY(0);\n          }\n        }\n\n        &.info {\n          &:hover {\n            background: #1571b9;\n            color: #fff;\n            border-color: #1571b9;\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);\n          }\n\n          &:active {\n            transform: translateY(0);\n          }\n        }\n\n        &.success {\n          &:hover {\n            background: #1571b9;\n            color: #fff;\n            border-color: #1571b9;\n            transform: translateY(-2px);\n            box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);\n          }\n\n          &:active {\n            transform: translateY(0);\n          }\n        }\n\n        i {\n          font-size: 1rem;\n          transition: transform 0.3s ease;\n        }\n\n        &:hover i {\n          transform: scale(1.1);\n        }\n\n        span {\n          @media (max-width: 480px) {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  // Desktop Table View\n  .desktop-view {\n    display: block;\n\n    @media (max-width: 768px) {\n      display: none;\n    }\n  }\n\n  .table-card {\n    background: #fff;\n    border-radius: 16px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    overflow-x: auto;\n    height: 66vh;\n    margin-bottom: 1rem;\n    border: 1px solid #e5e7eb;\n    transition: box-shadow 0.3s ease;\n\n    &:hover {\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n    }\n\n    .user-table {\n      width: 100%;\n      border-collapse: collapse;\n      min-width: 1200px; // Ensure table doesn't get too cramped with new columns\n\n      // Tablet optimization (750px - 1300px)\n      @media (min-width: 750px) and (max-width: 1300px) {\n        min-width: 100%;\n        \n        th,\n        td {\n          padding: 0.6rem 0.5rem;\n          font-size: 0.85rem;\n          white-space: normal;\n          word-wrap: break-word;\n        }\n\n        th:nth-child(1),\n        td:nth-child(1) {\n          min-width: 120px;\n          max-width: 150px;\n        }\n\n        th:nth-child(2),\n        td:nth-child(2) {\n          min-width: 180px;\n          max-width: 220px;\n          \n          div {\n            line-height: 1.4;\n            \n            &:first-child {\n              margin-bottom: 0.25rem;\n            }\n          }\n        }\n\n        th:nth-child(3),\n        td:nth-child(3) {\n          min-width: 120px;\n          max-width: 150px;\n        }\n\n        th:nth-child(4),\n        td:nth-child(4) {\n          min-width: 80px;\n          max-width: 100px;\n        }\n\n        th:nth-child(5),\n        td:nth-child(5) {\n          min-width: 110px;\n          max-width: 130px;\n        }\n\n        th:nth-child(6),\n        td:nth-child(6) {\n          min-width: 120px;\n          max-width: 140px;\n        }\n\n        .actions {\n          flex-wrap: wrap;\n          gap: 0.3rem;\n\n          .icon-btn {\n            padding: 0.25rem;\n            min-width: 32px;\n            min-height: 32px;\n\n            i {\n              font-size: 0.9rem;\n            }\n          }\n        }\n      }\n\n      th,\n      td {\n        padding: 0.75rem 0.65rem;\n        text-align: left;\n        border-bottom: 1px solid #f0f0f0;\n        white-space: nowrap;\n        font-size: 0.9rem;\n      }\n\n      thead {\n        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n        position: sticky;\n        top: 0;\n        z-index: 10;\n\n        th {\n          font-weight: 600;\n          font-size: 0.9rem;\n          color: #1f2937;\n          text-transform: uppercase;\n          letter-spacing: 0.2px;\n          padding: 0.75rem 0.65rem;\n        }\n      }\n\n      tbody {\n        tr {\n          transition: background-color 0.2s ease, box-shadow 0.2s ease;\n\n          &:hover {\n            background: #f8fafc;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n          }\n        }\n\n        .no-record {\n          text-align: center;\n          color: #9ca3af;\n          font-style: italic;\n          padding: 2rem;\n          font-size: 1rem;\n        }\n      }\n\n      .status {\n        padding: 0.4rem 0.8rem;\n        border-radius: 12px;\n        font-size: 0.85rem;\n        font-weight: 600;\n        display: inline-block;\n        transition: all 0.3s ease;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n        &.active {\n          background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n          color: #065f46;\n          border: 1px solid #6ee7b7;\n        }\n\n        &.inactive {\n          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n          color: #991b1b;\n          border: 1px solid #fca5a5;\n        }\n      }\n\n      .actions {\n        display: flex;\n        gap: 0.5rem;\n\n        .icon-btn {\n          background: none;\n          border: none;\n          padding: 0.5rem;\n          border-radius: 8px;\n          cursor: pointer;\n          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 36px;\n          height: 36px;\n\n          i {\n            font-size: 1.1rem;\n            transition: transform 0.3s ease;\n          }\n\n          &.success {\n            color: #10b981;\n\n            &:hover {\n              background: rgba(16, 185, 129, 0.15);\n              transform: translateY(-2px);\n              box-shadow: 0 4px 8px rgba(16, 185, 129, 0.2);\n\n              i {\n                transform: rotate(180deg) scale(1.1);\n              }\n            }\n          }\n\n          &.warning {\n            color: #1571b9;\n\n            &:hover {\n              background: rgba(21, 114, 185, 0.15);\n              transform: translateY(-2px);\n              box-shadow: 0 4px 8px rgba(21, 114, 185, 0.2);\n\n              i {\n                transform: scale(1.15);\n              }\n            }\n          }\n\n          &.danger {\n            color: #ef4444;\n\n            &:hover {\n              background: rgba(239, 68, 68, 0.15);\n              transform: translateY(-2px);\n              box-shadow: 0 4px 8px rgba(239, 68, 68, 0.2);\n\n              i {\n                transform: scale(1.15);\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Mobile Card View\n  .mobile-view {\n    display: none;\n\n    @media (max-width: 768px) {\n      display: block;\n    }\n\n    .no-record-card {\n      background: #fff;\n      border-radius: 12px;\n      padding: 2rem;\n      text-align: center;\n      color: #888;\n      font-style: italic;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    }\n\n    .client-card {\n      background: #fff;\n      border-radius: 12px;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n      margin-bottom: 1rem;\n      padding: 1rem;\n      transition: all 0.3s ease;\n\n      &:active {\n        transform: scale(0.98);\n      }\n\n      .client-card-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 1rem;\n        padding-bottom: 0.75rem;\n        border-bottom: 1px solid #eaeaea;\n\n        .client-name {\n          font-weight: 600;\n          font-size: 1.1rem;\n          color: #333;\n          flex: 1;\n        }\n\n        .status {\n          padding: 0.4rem 0.8rem;\n          border-radius: 12px;\n          font-size: 0.85rem;\n          font-weight: 600;\n          white-space: nowrap;\n          display: inline-block;\n          transition: all 0.3s ease;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n          &.active {\n            background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n            color: #065f46;\n            border: 1px solid #6ee7b7;\n          }\n\n          &.inactive {\n            background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n            color: #991b1b;\n            border: 1px solid #fca5a5;\n          }\n        }\n      }\n\n      .client-card-body {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin-bottom: 1rem;\n\n        .client-info-row {\n          display: flex;\n          align-items: flex-start;\n          gap: 0.75rem;\n\n          i {\n            color: #1571b9;\n            font-size: 1.1rem;\n            margin-top: 0.2rem;\n            min-width: 20px;\n          }\n\n          .info-label {\n            font-size: 0.75rem;\n            color: #666;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            margin-bottom: 0.25rem;\n          }\n\n          .info-value {\n            font-size: 0.95rem;\n            color: #333;\n            word-break: break-word;\n          }\n        }\n      }\n\n      .client-card-actions {\n        display: flex;\n        justify-content: flex-end;\n        gap: 0.5rem;\n        padding-top: 0.75rem;\n        border-top: 1px solid #eaeaea;\n\n        .icon-btn {\n          background: none;\n          border: none;\n          padding: 0.5rem;\n          border-radius: 6px;\n          cursor: pointer;\n          transition: all 0.3s ease;\n          min-width: 40px;\n          min-height: 40px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          i {\n            font-size: 1.1rem;\n          }\n\n          &.success {\n            color: #28a745;\n\n            &:active {\n              background: rgba(40, 167, 69, 0.2);\n            }\n          }\n\n          &.warning {\n            color: #1571b9;\n\n            &:active {\n              background: rgba(21, 114, 185, 0.2);\n            }\n          }\n\n          &.danger {\n            color: #dc3545;\n\n            &:active {\n              background: rgba(220, 53, 69, 0.2);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .pagination-container {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 1.5rem;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 14px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    font-family: 'Inter', sans-serif;\n    transition: all 0.3s ease-in-out;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n\n    // Tablet optimization (750px - 1300px)\n    @media (min-width: 750px) and (max-width: 1300px) {\n      padding: 0.65rem 1rem;\n    }\n\n    .pagination-info {\n      color: #374151;\n      font-size: 0.95rem;\n      font-weight: 500;\n\n      // Tablet optimization (750px - 1300px)\n      @media (min-width: 750px) and (max-width: 1300px) {\n        font-size: 0.9rem;\n      }\n\n      span {\n        background: #f3f4f6;\n        padding: 0.35rem 0.75rem;\n        border-radius: 8px;\n\n        @media (min-width: 750px) and (max-width: 1300px) {\n          padding: 0.3rem 0.65rem;\n        }\n      }\n    }\n\n    .pagination-controls {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      line-height: 1;\n\n      ::ng-deep {\n        .ngx-pagination {\n          margin: 0;\n          // display: flex;\n          list-style: none;\n          padding: 0;\n\n          li {\n            // display: inline-flex;\n            align-items: center;\n            vertical-align: middle;\n            margin: 0 0.25rem;\n            height: 30px;\n\n            &.active a {\n              background: linear-gradient(90deg, #2563eb, #1d4ed8);\n              color: #fff !important;\n              border-color: transparent;\n            }\n\n            a {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              width: 38px;\n              height: 38px;\n              font-size: 0.9rem;\n              color: #374151;\n              background: #f9fafb;\n              border: 1.5px solid #e5e7eb;\n              border-radius: 10px;\n              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n              font-weight: 500;\n\n              &:hover {\n                background: #e5e7eb;\n                border-color: #1571b9;\n                color: #1571b9;\n                transform: translateY(-2px);\n                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n              }\n            }\n\n            &.disabled a {\n              opacity: 0.5;\n              cursor: not-allowed;\n            }\n          }\n          .current span{\n            height: 25px;\n            display: flex;\n            align-items: center;\n          }\n        }\n      }\n    }\n\n\n    @media (max-width: 600px) {\n      flex-direction: column;\n      align-items: center;\n      gap: 0.75rem;\n\n      .pagination-info {\n        order: 2;\n      }\n\n      .pagination-controls {\n        order: 1;\n      }\n    }\n  }\n\n\n}\n\ntextarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1.5px solid #e0e4e8;\n  border-radius: 10px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: #fff;\n  font-size: 0.95rem;\n  font-family: inherit;\n  resize: vertical;\n\n  // Tablet optimization (750px - 1300px)\n  @media (min-width: 750px) and (max-width: 1300px) {\n    padding: 0.55rem 0.6rem;\n    font-size: 0.9rem;\n  }\n\n  @media (max-width: 480px) {\n    padding: 0.75rem;\n    font-size: 1rem; // Prevent zoom on iOS\n  }\n\n  &:focus {\n    border-color: #1571b9;\n    box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12);\n    outline: none;\n    transform: translateY(-1px);\n  }\n\n  &::placeholder {\n    color: #9ca3af;\n  }\n}\n\n.custom-modal {\n  position: fixed;\n  inset: 0;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n\n  &.is-active {\n    display: flex;\n  }\n\n  .custom-modal-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.6);\n  }\n\n  .custom-modal-container {\n    position: relative;\n    z-index: 2;\n    background: #fff;\n    border-radius: 1.25rem;\n    width: 90%;\n    max-width: 800px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n    overflow-y: auto;\n    max-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    padding: 1.5rem 2rem;\n    animation: modalSlideIn 0.3s ease-out;\n\n    @keyframes modalSlideIn {\n      from {\n        opacity: 0;\n        transform: translateY(-20px) scale(0.95);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n      }\n    }\n\n    // Tablet optimization (750px - 1300px)\n    @media (min-width: 750px) and (max-width: 1300px) {\n      width: 85%;\n      max-width: 750px;\n      padding: 1rem 1.25rem;\n      max-height: 95vh;\n    }\n\n    @media (max-width: 768px) {\n      width: 95%;\n      max-height: 95vh;\n      border-radius: 0.75rem;\n    }\n\n    @media (max-width: 480px) {\n      width: 100%;\n      max-height: 100vh;\n      border-radius: 0;\n      padding: 0.75rem;\n    }\n  }\n\n  .custom-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 2px solid #f0f0f0;\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n    order: 0;\n\n    h2 {\n      font-size: 1.5rem;\n      font-weight: 700;\n      color: #1f2937;\n      margin: 0;\n    }\n\n    .close-btn {\n      background: #f3f4f6;\n      border: none;\n      font-size: 1.2rem;\n      cursor: pointer;\n      color: #6b7280;\n      width: 36px;\n      height: 36px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.3s ease;\n\n      &:hover {\n        background: #e5e7eb;\n        color: #1f2937;\n        transform: rotate(90deg);\n      }\n    }\n  }\n\n  .custom-modal-body {\n    margin-top: 1rem;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .form-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    .input-row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 1rem;\n      align-items: flex-start;\n\n      // Tablet optimization (750px - 1300px)\n      @media (min-width: 750px) and (max-width: 1300px) {\n        gap: 0.875rem;\n      }\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        gap: 0.75rem;\n      }\n\n      .input-group {\n        flex: 1;\n        min-width: 200px;\n        display: flex;\n        flex-direction: column;\n\n        // Tablet optimization (750px - 1300px)\n        @media (min-width: 750px) and (max-width: 1300px) {\n          min-width: 180px;\n          flex: 1 1 calc(33.333% - 0.583rem);\n          \n          // For rows with 2 fields, make them 50% each\n          &:only-child,\n          &:nth-child(2):last-child {\n            flex: 1 1 calc(50% - 0.4375rem);\n          }\n        }\n\n        @media (max-width: 768px) {\n          min-width: 100%;\n          flex: 1 1 100%;\n        }\n\n        label {\n          font-weight: 500;\n          display: block;\n          margin-bottom: 0.4rem;\n          font-size: 0.9rem;\n\n          @media (max-width: 480px) {\n            font-size: 0.85rem;\n          }\n\n          span {\n            color: #ff4757;\n          }\n        }\n\n        input,\n        select {\n          width: 100%;\n          padding: 0.6rem;\n          border: 1px solid #ccc;\n          border-radius: 0.5rem;\n          transition: all 0.3s;\n          font-size: 0.95rem;\n\n          // Tablet optimization (750px - 1300px)\n          @media (min-width: 750px) and (max-width: 1300px) {\n            padding: 0.55rem 0.6rem;\n            font-size: 0.9rem;\n          }\n\n          @media (max-width: 480px) {\n            padding: 0.75rem;\n            font-size: 1rem; // Prevent zoom on iOS\n          }\n\n          &:focus {\n            border-color: #1571b9;\n            box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12);\n            outline: none;\n            transform: translateY(-1px);\n          }\n\n          &::placeholder {\n            color: #9ca3af;\n          }\n        }\n\n        form-validation {\n          display: block;\n          margin-top: 0.25rem;\n          min-height: 1.2rem;\n        }\n      }\n\n      &.full-width {\n        width: 100%;\n      }\n    }\n\n    .profile-section {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-bottom: 0.5rem;\n\n      .profile-wrapper {\n        position: relative;\n        text-align: center;\n\n        .profile-image {\n          width: 100px;\n          height: 100px;\n          border-radius: 50%;\n          object-fit: cover;\n          border: 3px solid #e5e7eb;\n          margin-bottom: 0.5rem;\n          transition: all 0.3s ease;\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n\n          &:hover {\n            border-color: #1571b9;\n            box-shadow: 0 6px 16px rgba(21, 113, 185, 0.2);\n            transform: scale(1.05);\n          }\n\n          @media (max-width: 480px) {\n            width: 80px;\n            height: 80px;\n          }\n        }\n\n        .profile-action {\n          display: flex;\n          justify-content: center;\n          gap: 0.5rem;\n          flex-wrap: wrap;\n\n          .file-label {\n            cursor: pointer;\n            color: #1571b9;\n            font-size: 1rem;\n            padding: 0.5rem;\n\n            @media (max-width: 480px) {\n              font-size: 0.9rem;\n            }\n          }\n\n          .remove-btn {\n            background: none;\n            border: none;\n            color: #ff4757;\n            cursor: pointer;\n            font-size: 0.9rem;\n            padding: 0.5rem;\n\n            @media (max-width: 480px) {\n              font-size: 0.85rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .custom-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    border-top: 1px solid #eee;\n    padding-top: 0.8rem;\n    margin-top: 1rem;\n\n    // Tablet optimization (750px - 1300px)\n    @media (min-width: 750px) and (max-width: 1300px) {\n      gap: 0.875rem;\n      padding-top: 0.75rem;\n    }\n\n    @media (max-width: 480px) {\n      flex-direction: column-reverse;\n      gap: 0.75rem;\n    }\n\n    .primary-btn {\n      background: linear-gradient(135deg, #1571b9 0%, #0d5a9a 100%);\n      color: #fff;\n      border: none;\n      border-radius: 10px;\n      padding: 0.75rem 1.8rem;\n      cursor: pointer;\n      font-weight: 600;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      box-shadow: 0 4px 12px rgba(21, 113, 185, 0.3);\n      font-size: 0.95rem;\n\n      // Tablet optimization (750px - 1300px)\n      @media (min-width: 750px) and (max-width: 1300px) {\n        padding: 0.55rem 1.2rem;\n        font-size: 0.9rem;\n      }\n\n      @media (max-width: 480px) {\n        width: 100%;\n        padding: 0.75rem 1rem;\n        font-size: 1rem;\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n\n      &:hover:not(:disabled) {\n        background-color: #1571b9;\n      }\n\n      &:active:not(:disabled) {\n        transform: scale(0.98);\n      }\n    }\n\n    .cancel-btn {\n      background-color: #f9fafb;\n      color: #374151;\n      border: 1.5px solid #e5e7eb;\n      border-radius: 10px;\n      padding: 0.75rem 1.8rem;\n      cursor: pointer;\n      font-weight: 600;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      font-size: 0.95rem;\n\n      // Tablet optimization (750px - 1300px)\n      @media (min-width: 750px) and (max-width: 1300px) {\n        padding: 0.55rem 1.2rem;\n        font-size: 0.9rem;\n      }\n\n      @media (max-width: 480px) {\n        width: 100%;\n        padding: 0.75rem 1rem;\n        font-size: 1rem;\n      }\n\n      &:hover {\n        background-color: #f3f4f6;\n        border-color: #d1d5db;\n        transform: translateY(-2px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  .file-upload-section {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n\n    input[type=\"file\"] {\n      padding: 0.5rem;\n      border: 1px solid #ccc;\n      border-radius: 0.5rem;\n      background: #fff;\n      cursor: pointer;\n    }\n\n    .attachment-list {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      margin-top: 0.5rem;\n\n      .attachment-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0.5rem;\n        background: #f5f5f5;\n        border-radius: 0.4rem;\n        font-size: 0.9rem;\n\n        @media (max-width: 480px) {\n          padding: 0.75rem;\n          font-size: 0.85rem;\n        }\n\n        span {\n          flex: 1;\n          word-break: break-word;\n          margin-right: 0.5rem;\n        }\n\n        .remove-attachment {\n          background: none;\n          border: none;\n          color: #dc3545;\n          cursor: pointer;\n          padding: 0.2rem 0.5rem;\n          border-radius: 0.3rem;\n          transition: all 0.2s;\n          flex-shrink: 0;\n\n          &:hover {\n            background: rgba(220, 53, 69, 0.1);\n          }\n\n          &:active {\n            background: rgba(220, 53, 69, 0.2);\n          }\n\n          i {\n            font-size: 0.9rem;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
